import { atom } from 'jotai'

export const v3WithdrawalBalanceAtom = atom<{
  [chainId: string]: {
    [tokenId: string]: string
  }
}>({})
